<template>
  <section class="box_license">
    <div class="container">
      <a-form ref="form" class="box_form"
              :model="form.data" :rules="form.rule"
              labelAlign="right" :labelCol="{span:3}">
        <a-form-item name="code">
          <template #label>
            <a-tooltip placement="topLeft"
                       title="申请码请安装软件后，点击订阅获取">
              <span>
                申请码
                <ExclamationCircleOutlined class="tip" />
              </span>
            </a-tooltip>
          </template>
          <a-textarea v-model:value="form.data.code" placeholder="请输入申请码"
                      :autoSize="{minRows:6,maxRows:10}" :maxlength="1000"
                      showCount allowClear />
        </a-form-item>
        <a-form-item label="申请人" name="applicant">
          <a-input class="input"
                   v-model:value="form.data.applicant" placeholder="请输入申请人的姓名"
                   :maxlength="100" allowClear />
        </a-form-item>
        <a-form-item label="公司/学校" name="company">
          <a-input class="input"
                   v-model:value="form.data.company" placeholder="请输入公司/学校的全称"
                   :maxlength="100" allowClear />
        </a-form-item>
        <a-form-item label="邀请码" name="invite">
          <a-input class="input"
                   v-model:value="form.data.invite" placeholder="邀请码"
                   :maxlength="100" allowClear />
        </a-form-item>
        <a-form-item label="版本" name="category">
          <a-radio-group v-model:value="form.data.category"
                         button-style="solid">
            <a-radio-button v-for="v in enumType.LicenseTypeDict"
                            :value="v.value" :disabled="v.expand?.disabled">
              {{ v.label }}
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="产品" name="name">
          <a-radio-group v-model:value="form.data.name"
                         button-style="solid" @change="getLicenseInfo()">
            <a-radio-button v-for="v in enumType.LicenseNameDist"
                            :value="v.value" :disabled="v.expand?.disabled">
              {{ v.label }}
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="成员数" name="member">
          <a-radio-group v-model:value="form.data.member"
                         button-style="solid">
            <a-radio-button v-for="v in request.data.member"
                            :value="v">
              {{ v }}
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="应用数" name="app">
          <a-radio-group v-model:value="form.data.app"
                         button-style="solid">
            <a-radio-button v-for="v in request.data.app"
                            :value="v">
              {{ v }}
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="购买时长（月）" name="expire">
          <a-radio-group v-model:value="form.data.expire"
                         button-style="solid">
            <a-radio-button v-for="v in request.data.expire"
                            :value="v">
              {{ v }}
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="订单金额（元）" name="money">
          {{ form.data.money }}
        </a-form-item>
        <a-form-item :wrapperCol="{offset:$FN.Agent.client()==='PC'?3:0}"
                     class="box_button">
          <a-button type="primary"
                    @click="clickBuy()">
            立即购买
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </section>
  <a-modal v-model:visible="modal.license"
           title="购买成功" :footer="null">
    <a-tag class="box_tag" color="warning">
      <a-space :size="5">
        <ExclamationCircleOutlined />
        <div class="content">
          请保存您的license。当前窗口关闭后，无法再次查询license。<br>
          如果您遗失了这个license，可以创建新的来替代。
        </div>
      </a-space>
    </a-tag>
    <a-form class="box_form_modal" labelAlign="right">
      <a-form-item label="许可证" name="license"
                   class="no_margin">
        {{ form.data.license }}
        <a-button type="link" size="small"
                  @click="$FN.CopyClipboard(form.data.license)">
          <template #icon>
            <CopyOutlined />
          </template>
          复制
        </a-button>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script lang="ts" type="text/tsx">
import {
  ExclamationCircleOutlined,
  CopyOutlined,
} from '@ant-design/icons-vue';

import { DataInterface } from '@interface/public';
import {
  LicenseTypeEnum, LicenseTypeDict,
  LicenseNameEnum, LicenseNameDist,
  RequestGetLicenseInfo, ResponseGetLicenseInfo, AxiosGetLicenseInfo,
  RequestApplyLicense, ResponseApplyLicense, AxiosApplyLicense
} from '@server/apiLicense';

export default {
  name: 'license',
  components: {
    ExclamationCircleOutlined,
    CopyOutlined
  },
  data(): DataInterface {
    return {
      enumType: {
        LicenseTypeDict,
        LicenseNameDist
      },
      request: {
        intercept: {
          info: false,
          apply: false
        },
        data: {
          list: [],
          member: [],
          app: [],
          expire: []
        }
      },
      form: {
        rule: {
          code: ((name: string) => [
            $Check.Rule.Required(name, 'input'),
            $Check.Rule.Format(name, $RegExp.Format.NoSpace, name + $Check.Text.ErrorNoSpace)
          ])('申请码'),
          applicant: ((name: string) => [
            $Check.Rule.Required(name, 'input')
          ])('申请人'),
          company: ((name: string) => [
            $Check.Rule.Required(name, 'input')
          ])('公司'),
          category: [ $Check.Rule.Required('版本', 'select') ],
          name: [ $Check.Rule.Required('产品', 'select') ],
          member: [ $Check.Rule.Required('成员数', 'select') ],
          app: [ $Check.Rule.Required('应用数', 'select') ],
          expire: [ $Check.Rule.Required('购买时长', 'select') ]
        },
        data: {
          code: '',
          applicant: '',
          company: '',
          invite: '',
          category: LicenseTypeEnum.Free,
          name: LicenseNameEnum.AIPilot,
          version: 'v1.0.0',
          member: 0,
          app: 0,
          expire: 0,
          license: '',
          money: 0
        },
        cache: null
      },
      modal: {
        license: false
      }
    };
  },
  mounted(): void {
    if (!$RQ.SSO.check()) {
      $RQ.SSO.login();
      return;
    }
    
    this.getLicenseInfo();
  },
  methods: {
    /**
     * 点击购买
     */
    clickBuy(): void {
      this.$refs.form.validateFields()
        .then(() => {
          this.applyLicense();
        })
        .catch(() => {
          $FN.Message('warning', { content: '表单校验失败' });
        });
    },
    
    /**
     * 获取许可证信息
     */
    async getLicenseInfo(): Promise<any> {
      if (this.request.intercept.info) return;
      this.request.intercept.info = true;
      
      await AxiosGetLicenseInfo({
        product_name: this.form.data.name
      } as RequestGetLicenseInfo)
        .then((response: any) => {
          const data: ResponseGetLicenseInfo = response.data;
          
          if (data.code !== $Enum.CodeEnum.Normal) return;
          
          this.request.data.list = data.data.rules;
          this.request.data.list.forEach((v, i) => {
            if (i !== 0) return;
            
            this.request.data.member = [ v.member_limit ];
            this.request.data.app = [ v.app_limit ];
            this.request.data.expire = [ v.expire_month ];
            this.form.data.member = v.member_limit;
            this.form.data.app = v.app_limit;
            this.form.data.expire = v.expire_month;
          });
        })
        .finally(() => {
          this.request.intercept.info = false;
        });
    },
    
    /**
     * 申请许可证
     */
    async applyLicense(): Promise<any> {
      if (this.request.intercept.apply) return;
      this.request.intercept.apply = true;
      
      await AxiosApplyLicense({
        request_code: this.form.data.code,
        applicant: this.form.data.applicant,
        company: this.form.data.company,
        product_name: this.form.data.name,
        product_category: this.form.data.category,
        product_release_version: this.form.data.version,
        member_limit: this.form.data.member,
        app_limit: this.form.data.app,
        expire_month: this.form.data.expire,
        extra: JSON.stringify({
          invite_code: this.form.data.invite
        })
      } as RequestApplyLicense)
        .then((response: any) => {
          const data: ResponseApplyLicense = response.data;
          
          if (data.code !== $Enum.CodeEnum.Normal || !data.data) return;
          
          this.form.data.license = data.data.license;
          this.modal.license = true;
        })
        .finally(() => {
          this.request.intercept.apply = false;
        });
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/license/';

.box_license {
  overflow: hidden;
  position: relative;
  z-index: 0;
  width: 100%;
  padding: 130px @padding 50px;
  background-color: @color_white;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    margin: 0 auto;
    .borderBox();
  }
}

.box_form {
  &:deep(.ant-form-item-label) {
    width: 120px;
  }
  
  .tip {
    margin: 0 0 0 5px;
    color: @color_warning;
  }
  
  .input {
    max-width: 500px;
  }
  
  .box_button {
    margin: 0;
  }
}

.box_form_modal {
  margin: 10px 0 0;
  
  &:deep(.ant-form-item-control) {
    padding: 4px 0 0;
  }
}

.box_tag {
  display: block;
  width: 100%;
  padding: 10px;
  word-break: break-all;
  word-wrap: break-word;
  white-space: pre-wrap;
  
  .ant-space {
    align-items: flex-start;
  }
  
  .content {
    color: @color_13;
  }
}

.no_margin {
  margin: 0 !important;
}

@media screen and (max-width: -1px+@grid_xl) {
  .box_license {
    padding: 90px @padding 30px;
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .box_form {
    .box_button {
      padding: 0;
      text-align: center;
    }
  }
}
</style>